import { Configuration } from './gen/shared'
import { Configuration as LegacyConfiguration } from './gen/legacy'

export const RestApiConfiguration = new Configuration({ basePath: '/api/rest/v1' })

export const AuthApiConfiguration = new Configuration({ basePath: '/api/auth/v1' })

export const StorageApiConfiguration = new Configuration({ basePath: '/api/storage' })

export const AdminConsoleApiConfiguration = new Configuration({ basePath: '/api/admin' })

export const LegacyApiConfiguration = new LegacyConfiguration({
  basePath: '/rest',
  baseOptions: {
    withCredentials: true,
    headers: {
      'Cache-Control': 'no-cache',
    },
  },
})
